import React, { Component } from 'react'
import styles from './styles/document-link.scss'

import documentIcon from './../assets/images/document.svg'

export default class DocumentLink extends Component {
  render() {
    const { href, text } = this.props

    return (
      <a href={href} className={styles.documentLink}>
        <img src={documentIcon} />
        {text}
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentLink.js